module.exports = __webpack_public_path__ + "img/orange_076.4e98ec7b.png";